import { config, backgroundColor, textSize, color, zIndex } from '@portal/kit/pkg/styles'
import { createUseStyles } from 'react-jss'
export default createUseStyles(theme => ({
  main: {
    position: 'relative',
    ...zIndex('mainContainer'),
    ...backgroundColor('selfcareContentBackground'),
    minHeight: '100vh'
  },
  globalLayer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    ...zIndex('pageLayer'),
    backgroundColor: 'rgba(0, 0, 0, .55)'
  },
  content: {
    position: 'relative',
    ...zIndex('pageContent'),
    padding: '20px 0 90px 0'
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    ...zIndex('header'),
    ...backgroundColor('mainBackground'),
    padding: '12px 12px 7px 12px',
    boxShadow: '0 2px 6px 0 rgba(0, 0, 0, .5)',
    ...textSize(10, 16),
    textAlign: 'center',
     width: '100%'
  },
  footerLine: {
    display: 'block'
  },
  footerItem: {
    display: 'inline-block',
    padding: '0 10px',
    marginBottom: 5,
    borderRight: `1px solid ${config.colors.textSecondary}`,
    whiteSpace: 'nowrap',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  footerItemLink: {
    ...color('textDefault')
  },
  [config.mediaQueries.tabletPortrait]: {
    main: {
      height: '100vh',
      maxWidth: 620,
      margin: '0 auto',
      boxShadow: config.colors.mainShadow
    },
    content: {
      padding: '20px 24px',
      overflowY: 'scroll',
      ...backgroundColor('selfcareContentBackground'),
      paddingBottom: 80,
    },
    footer: {
      maxWidth: 620,
    },
    footerLine: {
      display: 'inline-block',
      '&:last-child': {
        '& $footerItem': {
          '&:last-child': {
            borderRight: 'none'
          }
        }
      }
    },
    footerItem: {
      '&:last-child': {
        borderRight: `1px solid ${config.colors.textSecondary}`
      }
    }
  }
}))
